import apis from './apis';

/**
 * Living Documents (Epic B) - draft ↔ structure-template lineage.
 *
 * A draft generated from a structure template is "behind" once that template is
 * edited (via either the section editor or the markdown editor). These helpers
 * let the draft view show a passive "template updated" banner and trigger a
 * surgical, delta-only re-run of just the affected sections.
 */

export interface DraftSourceStatus {
  linked: boolean;
  status: 'up_to_date' | 'behind' | 'unversioned' | 'unlinked';
  from_version?: number | null;
  to_version?: number | null;
}

/** Passive check - never queues anything. */
export async function getDraftSourceStatus(draftUuid: string): Promise<DraftSourceStatus> {
  const res = await apis.get(`/drafting/drafts/${draftUuid}/source-status`);
  return res.data as DraftSourceStatus;
}

export interface RerunFromSourceResult {
  status: 'queued' | 'up_to_date' | 'no_baseline';
  /** Present with 'no_baseline' - human-readable reason to show the user. */
  reason?: string;
  generation_id?: string;
  from_version?: number | null;
  to_version?: number | null;
  /** Present when queued - the live generation group to join for progress. */
  pubsub?: { hub: string; group: string; correlation_id: string };
}

/** Enqueue a delta-only re-run bringing the draft up to the template's latest version. */
export async function rerunDraftFromSource(draftUuid: string): Promise<RerunFromSourceResult> {
  const res = await apis.post(`/drafting/drafts/${draftUuid}/rerun-from-source`, {});
  return res.data as RerunFromSourceResult;
}
